import { IKnowledgeAreaResponse } from 'services/knowledge-area/knowledge-area.interface';
import { IKnowledgeArea } from 'views/pages/KnowledgeArea/knowledge-area.interface';

function convertKnowledgeAreaToTable(
  knowledgeAreas: IKnowledgeAreaResponse[],
): IKnowledgeArea[] {
  return knowledgeAreas.map(
    ({ id, description, category, name, organization, levels }) => ({
      id,
      name,
      category: category.name,
      description,
      organization,
      levels,
    }),
  );
}

export { convertKnowledgeAreaToTable };
